module.exports = __webpack_public_path__ + "img/border_card.95622797.svg";